import * as React from "react";
import { SVGProps } from "react";

const Ecash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 256 256"
    {...props}
  >
    <defs>
      <linearGradient
        id="New_Gradient_Swatch_2"
        x1={-91.22}
        x2={342.81}
        y1={-135.07}
        y2={385.77}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#273498" />
        <stop offset={0.53} stopColor="#0074c2" />
        <stop offset={1} stopColor="#00abe7" />
      </linearGradient>
      <style>{".cls-1{fill:#fff}"}</style>
    </defs>
    <path
      d="m145.1 99.82-31.71 18.26a2.61 2.61 0 0 0-1.31 2.29v15.32a2.48 2.48 0 0 0 1.31 2.21l13.28 7.66a2.36 2.36 0 0 0 2.53 0L184 114c9.3-5.38 9.3-20.88 0-26.26l-49.25-28.36a13.17 13.17 0 0 0-13.62 0L71.89 87.75A13.45 13.45 0 0 0 65 99.58c0 19 .08 37.91 0 56.82a13.45 13.45 0 0 0 6.85 11.83l49.24 28.45a13.54 13.54 0 0 0 13.62 0L184 168.23a13.31 13.31 0 0 0 6.77-11.83v-24.7l-58.62 33.92a8.31 8.31 0 0 1-8.48 0l-26.18-15.17a8.3 8.3 0 0 1-4.24-7.34v-30.24a8.36 8.36 0 0 1 4.15-7.26c8.73-5.06 17.53-10.11 26.26-15.17a8.36 8.36 0 0 1 8.48 0l13 7.42a1.14 1.14 0 0 1-.04 1.96Z"
      className="cls-1"
    />
    <path
      d="M128 37.32A90.68 90.68 0 1 0 218.68 128 90.68 90.68 0 0 0 128 37.32Zm17.1 60.54-13-7.42a8.36 8.36 0 0 0-8.48 0c-8.73 5.06-17.53 10.11-26.26 15.17a8.36 8.36 0 0 0-4.15 7.26v30.24a8.3 8.3 0 0 0 4.24 7.34l26.17 15.17a8.31 8.31 0 0 0 8.48 0l58.62-33.92v24.7a13.31 13.31 0 0 1-6.72 11.83l-49.24 28.45a13.54 13.54 0 0 1-13.62 0l-49.25-28.45A13.45 13.45 0 0 1 65 156.4c.08-18.91 0-37.83 0-56.82a13.45 13.45 0 0 1 6.85-11.83l49.24-28.37a13.17 13.17 0 0 1 13.62 0L184 87.75c9.3 5.38 9.3 20.88 0 26.26l-54.8 31.55a2.36 2.36 0 0 1-2.53 0l-13.28-7.66a2.48 2.48 0 0 1-1.31-2.21v-15.32a2.61 2.61 0 0 1 1.31-2.29l31.71-18.26a1.14 1.14 0 0 0 0-1.96Z"
      className="cls-1"
    />
    <path
      fill="url(#New_Gradient_Swatch_2)"
      d="M128 0a128 128 0 1 0 128 128A128 128 0 0 0 128 0Zm17.1 97.86-13-7.42a8.36 8.36 0 0 0-8.48 0c-8.73 5.06-17.53 10.11-26.26 15.17a8.36 8.36 0 0 0-4.15 7.26v30.24a8.3 8.3 0 0 0 4.24 7.34l26.17 15.17a8.31 8.31 0 0 0 8.48 0l58.62-33.92v24.7a13.31 13.31 0 0 1-6.72 11.83l-49.24 28.45a13.54 13.54 0 0 1-13.62 0l-49.25-28.45A13.45 13.45 0 0 1 65 156.4c.08-18.91 0-37.83 0-56.82a13.45 13.45 0 0 1 6.85-11.83l49.24-28.37a13.17 13.17 0 0 1 13.62 0L184 87.75c9.3 5.38 9.3 20.88 0 26.26l-54.8 31.55a2.36 2.36 0 0 1-2.53 0l-13.28-7.66a2.48 2.48 0 0 1-1.31-2.21v-15.32a2.61 2.61 0 0 1 1.31-2.29l31.71-18.26a1.14 1.14 0 0 0 0-1.96Z"
    />
  </svg>
);

export default Ecash;
